// src/extensions/MuiAlert.js
import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import MuiAlertView from './MuiAlertView'

const MuiAlert = Node.create({
  name: 'muiAlert',
  group: 'block',
  content: 'inline*',
  atom: false,

  addAttributes() {
    return {
      severity: {
        default: 'info',
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-mui-alert]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-mui-alert': '' }), 0]
  },

  addNodeView() {
    return ReactNodeViewRenderer(MuiAlertView)
  },

  addCommands() {
    return {
      insertMuiAlert:
        (severity = 'info') =>
        ({ commands }) =>
          commands.insertContent({
            type: this.name,
            attrs: { severity },
            content: [{ type: 'text', text: 'This is an alert!' }],
          }),
    }
  },
})

export default MuiAlert
